import React from 'react';
import { Badge } from '../ui/badge';
import { CheckCircle, AlertTriangle, XCircle, Activity } from 'lucide-react';

const StatusBadge = ({ status }) => {
  const config = {
    healthy: { icon: CheckCircle, color: 'bg-green-100 text-green-800', label: 'Healthy' },
    warning: { icon: AlertTriangle, color: 'bg-yellow-100 text-yellow-800', label: 'Warning' },
    critical: { icon: XCircle, color: 'bg-red-100 text-red-800', label: 'Critical' },
    unknown: { icon: Activity, color: 'bg-gray-100 text-gray-800', label: 'Unknown' }
  };
  const { icon: Icon, color, label } = config[status] || config.unknown;
  
  return (
    <Badge className={`${color} flex items-center gap-1`}>
      <Icon className="h-3 w-3" />
      {label}
    </Badge>
  );
};

export default StatusBadge;
